module.exports = __webpack_public_path__ + "assets/img/25_320_big.f219402c.jpg";